module.exports = __webpack_public_path__ + "static/media/services-submenu-vision-products.7d9d0017.png";